export const serverRuntimeConfig = {
  graphqlApi: {
    url: process.env.GRAPHQL_API_URL,
    key: process.env.GRAPHQL_API_KEY,
  },
  invalidDeliveryKeys: process.env.INVALID_DELIVERY_KEYS?.split(',') ?? [],
  revalidate: {
    secret: process.env.REVALIDATE_SECRET,
  },
  reCaptcha: {
    secret: process.env.GOOGLE_RECAPTCHA_SECRET_KEY,
  },
};
